import { render, staticRenderFns } from "./historyClaim.vue?vue&type=template&id=487858c2&"
import script from "./historyClaim.vue?vue&type=script&lang=js&"
export * from "./historyClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports